//
//
//
//
//
//
//
//
//
//
//

import {base, prefix} from '../../common/mixins'

const iconMap = {
  success: 'icon-smile',
  error: 'icon-frown',
  cancel: 'icon-meh',
}

export default {
  name: 'Toast',
  mixins: [base, prefix],
  /* eslint-disable vue/require-default-prop */
  props: {
    value: Boolean,
    content: String,
    position: {
      type: String,
      default: 'middle',
    },
    type: {
      type: String,
      default: 'text',
    },
    time: {
      type: Number,
      default: 2000,
    },
  },
  /* eslint-enable */
  data () {
    return {
      show: false,
    }
  },
  computed: {
    transition () {
      if(this.position === 'top') return this.b('slide-in-down')
      if(this.position === 'bottom') return this.b('slide-in-up')
      return this.b('fade')
    },
    positionClass () {
      if(this.position === 'top' || this.position === 'bottom') {
        return this.c(this.position)
      }
      return this.c('middle')
    },
    iconClass () {
      return iconMap[this.type]
    },
    contentClass () {
      return this.showIcon ? this.c('content-with-icon') : this.c('content')
    },
    showIcon () {
      return Object.keys(iconMap).indexOf(this.type) > -1
    },
  },
  watch: {
    value (val) {
      this.show = val
    },
    show (val) {
      // 标签用法时需要发射一个input事件，修改v-model绑定的属性值
      this.$emit('input', val)
      val &&
        setTimeout(() => {
          this.show = false
        }, this.time)
    },
  },
  created () {
    if(this.value) {
      this.show = this.value
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/Dialog/Toast.vue